document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.trivex-benefit-card, .trivex-feature-item, .trivex-spec-table');

  if (!cards.length) return;

  cards.forEach(function (card) {
    card.style.opacity = '0';
    card.style.transform = 'translateY(18px)';
    card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  });

  const observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.18
  });

  cards.forEach(function (card) {
    observer.observe(card);
  });
});